import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Company } from '../models/user';
import { AuthenticationService } from '../services/authentication.service';

@Component({
  selector: 'app-company',
  templateUrl: './company.component.html',
  styleUrls: ['./company.component.scss'],
})
export class CompanyComponent implements OnInit {
  companies: Company[] = [];
  username: string = '';

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.username = this.route.snapshot.paramMap.get('username') || '';
    this.companies = this.authService.getCompaniesArr();

    if (!this.companies || this.companies.length === 0) {
      console.warn('No companies found. Redirecting to /auth');
      this.router.navigate(['/auth']);
    }
  }

  login(company: Company): void {
    this.authService.setCompanies([company]);
    this.authService.selectedCompany(company);
    this.router.navigate(['/auth/password', this.username]);
  }
}
